import { render } from "./DotSeparator.vue?vue&type=template&id=982f525e"
import script from "./DotSeparator.vue?vue&type=script&lang=ts"
export * from "./DotSeparator.vue?vue&type=script&lang=ts"
script.render = render

export default script